import { StyledSelect } from './styles'
import { DropDownProps } from 'components/Input/Dropdown'

function Select(props: DropDownProps) {
  return <StyledSelect {...props} />
}

export default Select
